<template>
  <div class="formbox">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="132px"
      labelPosition="center"
      class="registerform"
      hide-required-asterisk
      :disabled="disabled"
    >
      <!-- 名称 -->
      <!-- <el-form-item label="用户名" prop="name">
        <el-input v-model="ruleForm.name" size="large" ></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="称呼" prop="call">
        <el-select v-model="ruleForm.call" placeholder="请选择称呼">
          <el-option label="Dr." value="1"></el-option>
          <el-option label="Miss" value="2"></el-option>
          <el-option label="Mrs." value="3"></el-option>
          <el-option label="Prof" value="4"></el-option>
          <el-option label="先生" value="5"></el-option>
          <el-option label="女士" value="6"></el-option>
        </el-select>
      </el-form-item> -->

      <!-- 名字-->
      <el-form-item label="名字" prop="realname">
        <el-input v-model="ruleForm.realname" placeholder="未填写"></el-input>
      </el-form-item>

      <!--姓氏      -->
      <el-form-item label="姓氏" prop="surname">
        <el-input v-model="ruleForm.surname" placeholder="未填写"></el-input>
      </el-form-item>

      <!--邮箱地址      -->
      <el-form-item v-if="ruleForm.mail" label="邮箱地址" prop="mail">
        <el-input v-model="ruleForm.mail" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item v-else label="邮箱地址">
        <p class="rule-form-mail">
          未填写<span @click="gobind(5)">去绑定</span>
        </p>
      </el-form-item>

      <!--手机号      -->
      <el-form-item v-if="ruleForm.phone" label="手机号">
        <el-input v-model="ruleForm.phone" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item v-else label="手机号">
        <p class="rule-form-mail">
          未填写<span @click="gobind(5)">去绑定</span>
        </p>
      </el-form-item>

      <!--公司名称      -->
      <el-form-item label="公司名称" prop="compnay">
        <el-input v-model="ruleForm.compnay" placeholder="未填写"></el-input>
      </el-form-item>

      <!--行业      -->
      <el-form-item label="行业领域" prop="industry">
        <el-select v-model="ruleForm.industry" placeholder="请选择行业领域">
          <el-option label="工业机器人" value="1"></el-option>
          <el-option label="消费品加工制造" value="2"></el-option>
          <el-option label="智能家庭及商业应用" value="3"></el-option>
          <el-option label="仓储物流" value="4"></el-option>
          <el-option label="食品行业" value="5"></el-option>
          <el-option label="医疗行业" value="6"></el-option>
          <el-option label="汽车行业" value="7"></el-option>
          <el-option label="机械设备制造" value="8"></el-option>
          <el-option label="电子行业" value="9"></el-option>
        </el-select>
      </el-form-item>

      <!--国家 -->
      <el-form-item label="国家" prop="country">
        <el-select placeholder="请选择国籍" v-model="ruleForm.country">
          <el-option-group
            v-for="group in country"
            :key="group.label"
            :label="group.label"
          >
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.value
              }}</span>
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>

      <!--行业      -->
      <!-- <el-form-item label="工作职责" prop="duty">
        <el-select v-model="ruleForm.duty" placeholder="请选择工作职责">
          <el-option label="个人购买" value="1"></el-option>
          <el-option label="供应商管理和合同谈判" value="2"></el-option>
          <el-option label="元件生产组装" value="3"></el-option>
          <el-option label="厂房/机械维护" value="4"></el-option>
          <el-option label="机械制造和其他设备" value="5"></el-option>
          <el-option label="设备安装" value="6"></el-option>
          <el-option label="采购" value="7"></el-option>
          <el-option label="电子设计" value="8"></el-option>
          <el-option label="教育" value="9"></el-option>
          <el-option label="其他" value="10"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label-width="0" class="submitbutton">
        <el-button
          type="primary"
          round
          v-show="!disabled"
          @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
    <div class="submitbutton">
      <el-button type="info" round v-show="disabled" @click="edit()"
        >修改</el-button
      >
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      disabled: true,
      ruleForm: {
        // name: "",
        // call: "",
        realname: "",
        surname: "",
        compnay: "",
        country: "",
        mail: ""
        // industry: "1",
        // duty: "1",
      },
      //   dutylist: [
      //     {
      //       lable: "个人购买",
      //       values: 1,
      //     },
      //     {
      //       lable: "供应商管理和合同谈判",
      //       values: 2,
      //     },
      //     {
      //       lable: "元件生产组件",
      //       values: 3,
      //     },
      //     {
      //       lable: "厂房/机械维护",
      //       values: 4,
      //     },
      //     {
      //       lable: "机械制造和其他设备",
      //       values: 5,
      //     },
      //     {
      //       lable: "设备安装",
      //       values: 6,
      //     },
      //     {
      //       lable: "采购",
      //       values: 7,
      //     },
      //     {
      //       lable: "电子设计",
      //       values: 8,
      //     },
      //     {
      //       lable: "教育",
      //       values: 9,
      //     },
      //     {
      //       lable: "其他",
      //       values: 10,
      //     },
      //   ],
      //   calllist: [
      //     {
      //       lable: "Dr.",
      //       values: 1,
      //     },
      //     {
      //       lable: "Miss",
      //       values: 2,
      //     },
      //     {
      //       lable: "Mrs.",
      //       values: 3,
      //     },
      //     {
      //       lable: "Prof",
      //       values: 4,
      //     },
      //     {
      //       lable: "先生",
      //       values: 5,
      //     },
      //     {
      //       lable: "女士",
      //       values: 6,
      //     },
      //   ],
      industrylist: [
        {
          lable: "工业机器人",
          values: 1
        },
        {
          lable: "消费品加工制造",
          values: 2
        },
        {
          lable: "智能家庭及商业应用",
          values: 3
        },
        {
          lable: "仓储物流",
          values: 4
        },
        {
          lable: "食品行业",
          values: 5
        },
        {
          lable: "医疗行业",
          values: 6
        },
        {
          lable: "汽车行业",
          values: 7
        },
        {
          lable: "机械设备制造",
          values: 8
        },
        {
          lable: "电子行业",
          values: 9
        }
      ],
      rules: {
        // name: [
        //   { required: true, message: "请输入用户名", trigger: "blur" },
        //   {
        //     pattern: /^[0-9a-zA-Z_]+$/,
        //     message: "用户名必须是英文数字组合",
        //     trigger: "blur",
        //   },
        //   {
        //     min: 6,
        //     max: 16,
        //     message: "长度在 6 到 16 个字符",
        //     trigger: "blur",
        //   },
        // ],
        // call: [{ required: true, message: "请选择称呼", trigger: "change" }],
        realname: [
          { message: "名", trigger: "blur" },
          { min: 1, max: 10, message: "长度在1 到 10 个字符", trigger: "blur" }
        ],
        surname: [
          { message: "姓", trigger: "blur" },
          { min: 1, max: 10, message: "长度在1 到 10 个字符", trigger: "blur" }
        ],
        compnay: [
          { message: "请输入公司名称", trigger: "blur" },
          { min: 2, max: 16, message: "长度在2 到 16 个字符", trigger: "blur" }
        ],
        // country: [{ required: true, message: "请选择国家", trigger: "change" }],
        mail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "请检查邮箱格式",
            trigger: "blur"
          }
        ]
        // industry: [
        //   { required: true, message: "请选择行业", trigger: "change" },
        // ],

        // duty: [
        //   { required: true, message: "请选择你的职责", trigger: "change" },
        // ],
      },

      country: [
        {
          label: "热门国家",
          options: [{ value: "China", label: "中国" }]
        },
        {
          label: "所有国家",
          options: [
            { value: "Angola", label: "安哥拉" },
            { value: "Afghanistan", label: "阿富汗" },
            { value: "Albania", label: "阿尔巴尼亚" },
            { value: "Algeria", label: "阿尔及利亚" },
            { value: "Andorra", label: "安道尔共和国" },
            { value: "Anguilla", label: "安圭拉岛" },
            { value: "Antigua and Barbuda", label: "安提瓜和巴布达" },
            { value: "Argentina", label: "阿根廷" },
            { value: "Armenia", label: "亚美尼亚" },
            { value: "Ascension", label: "阿森松" },
            { value: "Australia", label: "澳大利亚" },
            { value: "Austria", label: "奥地利" },
            { value: "Azerbaijan", label: "阿塞拜疆" },
            { value: "Bahamas", label: "巴哈马" },
            { value: "Bahrain", label: "巴林" },
            { value: "Bangladesh", label: "孟加拉国" },
            { value: "Barbados", label: "巴巴多斯" },
            { value: "Belarus", label: "白俄罗斯" },
            { value: "Belgium", label: "比利时" },
            { value: "Belize", label: "伯利兹" },
            { value: "Benin", label: "贝宁" },
            { value: "Bermuda Is", label: "百慕大群岛" },
            { value: "Bolivia", label: "玻利维亚" },
            { value: "Botswana", label: "博茨瓦纳" },
            { value: "Brazil", label: "巴西" },
            { value: "Brunei", label: "文莱" },
            { value: "Bulgaria", label: "保加利亚" },
            { value: "Burkina Faso", label: "布基纳法索" },
            { value: "Burma", label: "缅甸" },
            { value: "Burundi", label: "布隆迪" },
            { value: "Cameroon", label: "喀麦隆" },
            { value: "Canada", label: "加拿大" },
            { value: "Cayman Is", label: "开曼群岛" },
            { value: "Central African Republic", label: "中非共和国" },
            { value: "Chad", label: "乍得" },
            { value: "Chile", label: "智利" },
            { value: "China", label: "中国" },
            { value: "Colombia", label: "哥伦比亚" },
            { value: "Congo", label: "刚果" },
            { value: "Cook Is", label: "库克群岛" },
            { value: "Costa Rica", label: "哥斯达黎加" },
            { value: "Cuba", label: "古巴" },
            { value: "Cyprus", label: "塞浦路斯" },
            { value: "Czech Republic", label: "捷克" },
            { value: "Denmark", label: "丹麦" },
            { value: "Djibouti", label: "吉布提" },
            { value: "Dominica Rep", label: "多米尼加共和国" },
            { value: "Ecuador", label: "厄瓜多尔" },
            { value: "Egypt", label: "埃及" },
            { value: "EI Salvador", label: "萨尔瓦多" },
            { value: "Estonia", label: "爱沙尼亚" },
            { value: "Ethiopia", label: "埃塞俄比亚" },
            { value: "Fiji", label: "斐济" },
            { value: "Finland", label: "芬兰" },
            { value: "France", label: "法国" },
            { value: "French Guiana", label: "法属圭亚那" },
            { value: "French Polynesia", label: "法属玻利尼西亚" },
            { value: "Gabon", label: "加蓬" },
            { value: "Gambia", label: "冈比亚" },
            { value: "Georgia", label: "格鲁吉亚" },
            { value: "Germany", label: "德国" },
            { value: "Ghana", label: "加纳" },
            { value: "Gibraltar", label: "直布罗陀" },
            { value: "Greece", label: "希腊" },
            { value: "Grenada", label: "格林纳达" },
            { value: "Guam", label: "关岛" },
            { value: "Guatemala", label: "危地马拉" },
            { value: "Guinea", label: "几内亚" },
            { value: "Guyana", label: "圭亚那" },
            { value: "Haiti", label: "海地" },
            { value: "Honduras", label: "洪都拉斯" },
            { value: "Hungary", label: "匈牙利" },
            { value: "Iceland", label: "冰岛" },
            { value: "India", label: "印度" },
            { value: "Indonesia", label: "印度尼西亚" },
            { value: "Iran", label: "伊朗" },
            { value: "Iraq", label: "伊拉克" },
            { value: "Ireland", label: "爱尔兰" },
            { value: "Israel", label: "以色列" },
            { value: "Italy", label: "意大利" },
            { value: "Ivory Coast", label: "科特迪瓦" },
            { value: "Jamaica", label: "牙买加" },
            { value: "Japan", label: "日本" },
            { value: "Jordan", label: "约旦" },
            { value: "Kampuchea (Cambodia )", label: "柬埔寨" },
            { value: "Kazakstan", label: "哈萨克斯坦" },
            { value: "Kenya", label: "肯尼亚" },
            { value: "Korea", label: "韩国" },
            { value: "Kuwait", label: "科威特" },
            { value: "Kyrgyzstan", label: "吉尔吉斯坦" },
            { value: "Laos", label: "老挝" },
            { value: "Latvia", label: "拉脱维亚" },
            { value: "Lebanon", label: "黎巴嫩" },
            { value: "Lesotho", label: "莱索托" },
            { value: "Liberia", label: "利比里亚" },
            { value: "Libya", label: "利比亚" },
            { value: "Liechtenstein", label: "列支敦士登" },
            { value: "Lithuania", label: "立陶宛" },
            { value: "Luxembourg", label: "卢森堡" },
            { value: "Madagascar", label: "马达加斯加" },
            { value: "Malawi", label: "马拉维" },
            { value: "Malaysia", label: "马来西亚" },
            { value: "Maldives", label: "马尔代夫" },
            { value: "Mali", label: "马里" },
            { value: "Malta", label: "马耳他" },
            { value: "Mariana Is", label: "马里亚那群岛" },
            { value: "Martinique", label: "马提尼克" },
            { value: "Mauritius", label: "毛里求斯" },
            { value: "Mexico", label: "墨西哥" },
            { value: "Moldova", label: "摩尔多瓦" },
            { value: "Monaco", label: "摩纳哥" },
            { value: "Mongolia", label: "蒙古" },
            { value: "Montserrat Is", label: "蒙特塞拉特岛" },
            { value: "Morocco", label: "摩洛哥" },
            { value: "Mozambique", label: "莫桑比克" },
            { value: "Namibia", label: "纳米比亚" },
            { value: "Nauru", label: "瑙鲁" },
            { value: "Nepal", label: "尼泊尔" },
            { value: "Netheriands Antilles", label: "荷属安的列斯" },
            { value: "Netherlands", label: "荷兰" },
            { value: "New Zealand", label: "新西兰" },
            { value: "Nicaragua", label: "尼加拉瓜" },
            { value: "Niger", label: "尼日尔" },
            { value: "Nigeria", label: "尼日利亚" },
            { value: "North Korea", label: "朝鲜" },
            { value: "Norway", label: "挪威" },
            { value: "Oman", label: "阿曼" },
            { value: "Pakistan", label: "巴基斯坦" },
            { value: "Panama", label: "巴拿马" },
            { value: "Papua New Cuinea", label: "巴布亚新几内亚" },
            { value: "Paraguay", label: "巴拉圭" },
            { value: "Peru", label: "秘鲁" },
            { value: "Philippines", label: "菲律宾" },
            { value: "Poland", label: "波兰" },
            { value: "Portugal", label: "葡萄牙" },
            { value: "Puerto Rico", label: "波多黎各" },
            { value: "Qatar", label: "卡塔尔" },
            { value: "Reunion", label: "留尼旺" },
            { value: "Romania", label: "罗马尼亚" },
            { value: "Russia", label: "俄罗斯" },
            { value: "Saint Lueia", label: "圣卢西亚" },
            { value: "Saint Vincent", label: "圣文森特岛" },
            { value: "Samoa Eastern", label: "东萨摩亚(美)" },
            { value: "Samoa Western", label: "西萨摩亚" },
            { value: "San Marino", label: "圣马力诺" },
            { value: "Sao Tome and Principe", label: "圣多美和普林西比" },
            { value: "Saudi Arabia", label: "沙特阿拉伯" },
            { value: "Senegal", label: "塞内加尔" },
            { value: "Seychelles", label: "塞舌尔" },
            { value: "Sierra Leone", label: "塞拉利昂" },
            { value: "Singapore", label: "新加坡" },
            { value: "Slovakia", label: "斯洛伐克" },
            { value: "Slovenia", label: "斯洛文尼亚" },
            { value: "Solomon Is", label: "所罗门群岛" },
            { value: "Somali", label: "索马里" },
            { value: "South Africa", label: "南非" },
            { value: "Spain", label: "西班牙" },
            { value: "SriLanka", label: "斯里兰卡" },
            { value: "St.Lucia", label: "圣卢西亚" },
            { value: "St.Vincent", label: "圣文森特" },
            { value: "Sudan", label: "苏丹" },
            { value: "Suriname", label: "苏里南" },
            { value: "Swaziland", label: "斯威士兰" },
            { value: "Sweden", label: "瑞典" },
            { value: "Switzerland", label: "瑞士" },
            { value: "Syria", label: "叙利亚" },
            { value: "Tajikstan", label: "塔吉克斯坦" },
            { value: "Tanzania", label: "坦桑尼亚" },
            { value: "Thailand", label: "泰国" },
            { value: "Togo", label: "多哥" },
            { value: "Tonga", label: "汤加" },
            { value: "Trinidad and Tobago", label: "特立尼达和多巴哥" },
            { value: "Tunisia", label: "突尼斯" },
            { value: "Turkey", label: "土耳其" },
            { value: "Turkmenistan", label: "土库曼斯坦" },
            { value: "Uganda", label: "乌干达" },
            { value: "Ukraine", label: "乌克兰" },
            { value: "United Arab Emirates", label: "阿拉伯联合酋长国" },
            { value: "United Kiongdom", label: "英国" },
            { value: "United States of America", label: "美国" },
            { value: "Uruguay", label: "乌拉圭" },
            { value: "Uzbekistan", label: "乌兹别克斯坦" },
            { value: "Venezuela", label: "委内瑞拉" },
            { value: "Vietnam", label: "越南" },
            { value: "Yemen", label: "也门" },
            { value: "Yugoslavia", label: "南斯拉夫" },
            { value: "Zimbabwe", label: "津巴布韦" },
            { value: "Zaire", label: "扎伊尔" },
            { value: "Zambia", label: "赞比亚" }
          ]
        }
      ]
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.user.saveUser(this.ruleForm).then(res => {
            if (res.data.errno == 0) {
              // var options={
              // 	message:"修改成功",
              // }
              // Message.success(options)
              this.$FUnitls.showInfo("修改成功", "success");
              this.disabled = true;
            } else {
              var options = {
                message: res.data.errmsg
              };
              this.$FUnitls.showInfo(res.data.errmsg, "error");
            }
          });
          // alert('submit!');
          // console.log(this.ruleForm);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    edit() {
      this.disabled = false;
    },
    gobind(val) {
      this.$emit("cNowindex", val);
    },
    //获取个人信息
    getUserInfo() {
      this.$api.user.getUserInfo().then(res => {
        //console.log(res.data.datas)

        //工作职责
        // var index=this.dutylist.findIndex((item)=>{
        // 					if(item.lable == res.data.datas.duty){
        // 						return true;
        // 					}
        // 				}
        // 			)
        // if(this.dutylist[index]==undefined){
        // 	index=0;
        // }
        // res.data.datas.duty = this.dutylist[index].values

        // //industry  行业
        // var index=this.industrylist.findIndex((item)=>{
        // 					if(item.lable == res.data.datas.industry){
        // 						return true;
        // 					}
        // 				}
        // 			)
        // if(this.industrylist[index]==undefined){
        // 	index=0;
        // }
        // res.data.datas.industry = this.industrylist[index].values
        // //称呼
        // var index=this.calllist.findIndex((item)=>{
        // 					if(item.lable == res.data.datas.call){
        // 						return true;
        // 					}
        // 				}
        // 			)
        // if(this.calllist[index]==undefined){
        // 	index=0;
        // }
        // res.data.datas.calllist = this.calllist[index].values
        if (res.data.errno == 0) {
          this.ruleForm = res.data.datas;
        } else {
          this.$router.push({ name: "login" });
        }
      });
    }
  },
  mounted() {
    this.getUserInfo();
  }
};
</script>

<style scoped>
.formbox >>> .el-form--label-left .el-form-item__label {
  color: #333333;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 540;
}
.formbox >>> .el-form-item__label {
  text-align: justify;
  text-align-last: justify;
  padding: 0 75px 0 0;
}
.formbox >>> .el-input,
.el-select {
  width: 380px;
}
.formbox
  >>> .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: "";
  color: #ff1111;
  font-size: 16px;
  margin-right: 4px;
  font-family: Microsoft YaHei, Heiti SC, tahoma, arial, Hiragino Sans GB,
    "\5B8B\4F53", sans-serif;
}
.formbox
  >>> .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:after {
  /* content: ' ';
          color: #ff1111;
          background: url('/static/redstar.png') no-repeat center;
          background-size: 6px 6px;
          padding-right: 8px; */
  content: "*";
  color: #ff1111;
  font-size: 16px;
  margin-right: 4px;
  font-family: Microsoft YaHei, Heiti SC, tahoma, arial, Hiragino Sans GB,
    "\5B8B\4F53", sans-serif;
}
.formbox >>> .xieyi {
  font-size: 14px;
  color: #9f9f9f;
}
.formbox >>> .xieyi .yinsi {
  color: #2655ae;
}
.formbox >>> .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #888888;
  border: 0px;
}
.formbox >>> .el-input.is-disabled .el-icon-arrow-up:before {
  content: "";
}
.submitbutton {
  text-align: center;
}
.formbox >>> .el-form-item:last-child {
  margin-bottom: 0;
}
.rule-form-mail {
  padding-left: 15px;
  color: #888888;
  overflow: hidden;
}
.rule-form-mail span {
  background-color: #2655ae;
  color: #fff;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 5px;
  margin-left: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserInfoShow.vue